import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {ProductService} from '../../services/product.service';
import {StoreService} from "../../services/store.service";
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, AfterViewInit {
  search: any = '';
  displayResult: boolean = false;
  searchResult: Array<any> = [];
  productId: number = 0;
  scConfig: boolean = false;
  @Output() onResult: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private store: StoreService, private productService: ProductService,
    private messageService: MessageService, private cd: ChangeDetectorRef,
    private translate: TranslateService, private router: Router) {
    router.events
      .subscribe((event: any) => {
        if (event.navigationTrigger === 'popstate' || (event.navigationTrigger === 'imperative' && !event.url?.includes('search'))) {
          this.search = null;
        }
      });
    if (environment.isStoreCloud) {
      this.scConfig = true;
    } else {
      this.scConfig = false;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit(): void {
    /**/
  }

  ngAfterViewInit(): void {
    this.store.subscription('search')
      .subscribe(
        (res: string) => {
          this.search = res;
        }
      );
  }

  searchProduct(event: any, searchKay?: any): void {

    if (searchKay.length > 0) {
      this.router.navigate(
        ['/search'],
        {queryParams: {q: searchKay}}
      );
    }
    if (event?.target?.value) {
      this.router.navigate(
        ['/search'],
        {queryParams: {q: event?.target?.value}}
      );
    }

  }

  showResultPopUp(show: boolean): void {
    this.displayResult = show;
    this.onResult.emit(this.displayResult);
  }

  NavigateToProduct(specProductId: any) {


    this.router.navigate(['product', specProductId]);
    this.showResultPopUp(false);

  }

  closeDropDown() {
    this.showResultPopUp(false);

  }

  searchChange(event: any) {
    const regex = /^[^a-zA-Z0-9]+/;


    this.search = event.replace(regex, '');
    this.cd.detectChanges();
    if (this.search === '') {
      this.search = null
    }


  }
}
